import { ProductCard, ProductCardProps } from '../ProductCard';

type ProductGridProps = Omit<ProductCardProps, 'product'> & {
  products: (ProductCardProps['product'] | null)[];
};

export const ProductGrid = ({ products, ...props }: ProductGridProps) => (
  <section className={'product-grid'}>
    {products.map((product) => {
      if (!product) {
        return null;
      }

      return <ProductCard {...props} key={product.id} product={product} />;
    })}
  </section>
);
